module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsSAAALEgHS3X78AAAA4klEQVQ4y6WSsXHDMAxFn1ihi1Kw5wjiBNEGmSEbyBs4I2QDZ4OMkEwAjhC3YSNXYac0sC++k3mMgha4h4//0S3Lwn/L1Zolx6nk+F5yHGtz3S0lJcce+ATugA/xOm5RMhkA4KGmxlVUTCvQ+jklxwAEYABG4HFl/gVIdmYSrzNA9/01DIBuDOYoXoOz7VurLzn2Try+AU8bACdgFK+zAxCvhz+CzoB0lY6Bdo2QC2At4tRC+A1YgwwtEHuHm5DWpEKrkqOZfQ88m5kXT2qQZMM78RrE60G8zuJ1b9tfrX/lyQ/m50v96Jk9sgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/actived_star.png
// module id = wCP4
// module chunks = 1